<template>
  <div
    :class="[
      'field--textarea',
      ...classObject
    ]"
  >
    <InputfieldLabel
      :for="fieldId"
      :text="label"
      :icon="icon"
    />
    <InputfieldDescription
      :text="description"
    >
      <slot name="description" />
    </InputfieldDescription>
    <div class="field__content">
      <textarea
        ref="inputfield"
        class="field__input field__input--textarea"
        v-bind="[$attrs, $listeners]"
        :id="fieldId"
        :name="name"
        :value="value"
        @input="onInput"
        @click="onClick"
      />
    </div>
    <InputfieldErrors :items="parsedErrors" />
    <InputfieldNotes :text="notes" />
  </div>
</template>

<script>

import InputfieldMixin from '@/components/forms/InputfieldMixin'
import InputfieldLabel from '@/components/forms/InputfieldLabel'
import InputfieldDescription from '@/components/forms/InputfieldDescription'
import InputfieldNotes from '@/components/forms/InputfieldNotes'
import autosize from 'autosize'

export default {
  name: 'InputfieldTextarea',
  inheritAttrs: false,
  mixins: [
    InputfieldMixin,
  ],
  components: {
    InputfieldLabel,
    InputfieldDescription,
    InputfieldNotes,
  },
  props: {
    autosize: {
      type: Boolean,
      required: false,
      default () {
        return true
      },
    },
    selectOnClick: {
      type: Boolean,
      required: false,
      default () {
        return false
      },
    },
  },
  methods: {
    onInput (e) {
      this.clearErrors()
      this.$emit('input', e.target.value)
    },
    onClick () {
      if (this.selectOnClick) {
        this.$refs.inputfield.select()
      }
    },
    focus () {
      this.$refs.inputfield.focus()
    },
  },
  watch: {
    value: {
      immediate: true,
      handler () {
        if (this.autosize) {
          this.$nextTick(() => {
            setTimeout(() => {
              autosize(this.$refs.inputfield)
            }, 200)
          })
        }
      },
    },
  },
}

</script>

<style lang="scss" scoped>

</style>
